import React, { Fragment } from 'react'
import { graphql } from 'react-apollo'
import { compose, lifecycle } from 'recompose'
import { withStyles } from '@material-ui/core/styles'

import withErrorState from '../hocs/withErrorState'
import withLoadingState from '../hocs/withLoadingState'
import withLocalization from '../hocs/withLocalization'
import withFlattenedTranslations from '../hocs/withFlattenedTranslations'
import withPageInfo from '../hocs/withPageInfo'
import withGeneralTranslations from '../hocs/withGeneralTranslations'
import withConnectionStatus from '../hocs/withConnectionStatus'
import withNotFoundWhenEmpty from '../hocs/withNotFoundWhenEmpty'

import Navigation from '../layouts/Navigation'
import { IntroSection, SummaryBar, ComponentSection } from '../components'

import componentQuery from '../queries/component'
import PodcastsReferences from "../components/PodcastsReferences";

export const sharedComponentStyles = () => ({
  mainWrapperStyle: {
    flex: '1 0 auto'
  },
  sectionsWrapperStyle: {
    padding: '10px 36px 0 36px',
    backgroundColor: '#fafafa'
  },
  sectionsWrapperPrintStyle: {
    padding: '10px 36px 0 36px',
    backgroundColor: '#fff'
  }
})

class Component extends React.Component {
  componentDidMount() {
    this.updatePageInfo()
  }

  componentDidUpdate() {
    this.updatePageInfo()
  }

  updatePageInfo() {
    const { component, pageInfo, setPageInfo } = this.props
    const { id, title } = component
    if (pageInfo.title !== title || pageInfo.id !== id) {
      setPageInfo({
        id,
        title,
        type: 'component'
      })
    }
  }

  render() {
    const { component, generalTranslations, match, classes } = this.props
    const { title, headline, description, sections } = component

    const isHowTo = match.path === '/how-to'

    return (
      <Fragment>
        <Navigation enableOverviewShortcuts={!isHowTo} />
        <div className={classes.mainWrapperStyle}>
          <IntroSection
            kicker={
              isHowTo ? 'HOWTO' : generalTranslations('component').toUpperCase()
            }
            title={title}
            headline={headline}
            description={description}
          >
            <PodcastsReferences podcasts={component.podcasts}/>
          </IntroSection>
          <SummaryBar sections={sections} />

          <div className={classes.sectionsWrapperStyle}>
            {sections.map((section, index) => {
              const {
                headline,
                description,
                slug,
                assetsWithDescription,
                table
              } = section

              return (
                <ComponentSection
                  headline={headline}
                  description={description}
                  medias={assetsWithDescription}
                  isLastSection={index === sections.length - 1}
                  key={slug}
                  anchorId={slug}
                  table={table}
                />
              )
            })}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default compose(
  withConnectionStatus,
  withGeneralTranslations,
  withLocalization,
  graphql(componentQuery, {
    options: ({ language, match, fetchPolicy, stage }) => ({
      variables: {
        slug: match.path === '/how-to' ? 'how-to' : match.params.slug,
        lang: language.toLowerCase(),
        stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('component'),
  withNotFoundWhenEmpty('component'),
  withFlattenedTranslations('component'),
  withPageInfo,
  withStyles(sharedComponentStyles)
)(Component)

const ComponentPrintView = ({ component, generalTranslations, classes }) => {
  const { title, headline, description, sections } = component

  if (!title || !description || !sections) {
    return <div>Component not fully loaded, cannot be printed!</div>
  }

  return (
    <Fragment>
      <div className={classes.mainWrapperStyle}>
        <IntroSection
          kicker={generalTranslations('component').toUpperCase()}
          title={title}
          headline={headline}
          description={description}
        />

        <div className={classes.sectionsWrapperPrintStyle}>
          {sections.map((section, index) => {
            const {
              headline,
              description,
              slug,
              assetsWithDescription,
              table
            } = section

            return (
              <ComponentSection
                headline={headline}
                description={description}
                medias={assetsWithDescription}
                isLastSection={index === sections.length - 1}
                key={slug}
                anchorId={slug}
                table={table}
              />
            )
          })}
        </div>
      </div>
    </Fragment>
  )
}

export const ComponentPrint = compose(
  withConnectionStatus,
  withGeneralTranslations,
  withLocalization,
  graphql(componentQuery, {
    options: ({ language, slug, fetchPolicy, stage }) => ({
      variables: {
        slug: slug,
        lang: language.toLowerCase(),
        stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('component'),
  withNotFoundWhenEmpty('component'),
  withFlattenedTranslations('component'),
  withStyles(sharedComponentStyles),
  lifecycle({
    componentDidMount() {
      this.props.onMounted(this.props.slug)
    }
  })
)(ComponentPrintView)



// WEBPACK FOOTER //
// ./src/screens/Component.js